/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calm_Rust_Crane_DoneInputs */

const en_calm_rust_crane_done = /** @type {(inputs: Calm_Rust_Crane_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleted report successfully`)
};

const de_calm_rust_crane_done = /** @type {(inputs: Calm_Rust_Crane_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bericht erfolgreich gelöscht`)
};

/**
* | output |
* | --- |
* | "Deleted report successfully" |
*
* @param {Calm_Rust_Crane_DoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const calm_rust_crane_done = /** @type {((inputs?: Calm_Rust_Crane_DoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_Rust_Crane_DoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calm_rust_crane_done(inputs)
	return de_calm_rust_crane_done(inputs)
});